import { combineReducers } from "redux";

import AlertsReducer, { IAlertsState } from "./Alerts";
import ConfirmReducer, { IConfirmState } from "./Confirm";
import MyzTokenUserReducer, { IMyzTokenUserState } from "./MyzTokenUser";
import SubscriptionEmailReducer, {
  ISubscriptionEmailState,
} from "./SubscriptionEmail";
import WotdFormDataReducer, { IWotdFormDataState } from "./WotdFormData";
import WotdPresetReducer, { IWotdPresetState } from "./WotdPreset";

export interface GlobalState {
  myztokenuser: IMyzTokenUserState;
  subscriptionemail: ISubscriptionEmailState;
  wotdformdata: IWotdFormDataState;
  wotdpreset: IWotdPresetState;
  confirm: IConfirmState;
  alerts: IAlertsState;
}

export default combineReducers<GlobalState>({
  myztokenuser: MyzTokenUserReducer,
  subscriptionemail: SubscriptionEmailReducer,
  wotdformdata: WotdFormDataReducer,
  wotdpreset: WotdPresetReducer,
  confirm: ConfirmReducer,
  alerts: AlertsReducer,
});
